var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement_pop"},[_c('div',{staticClass:"text gray_color",domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_vm._v(" "),_c('div',{staticClass:"close"},[_c('img',{attrs:{"src":require("@/assets/wallet/xx.png"),"alt":""},on:{"click":function($event){_vm.$parent.agreement_pop = false}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5654e7aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/agreement.vue
// module id = null
// module chunks = 